export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Official Minimum Age',
        category: 'Game',
        description: 'Publisher selected minimum age for the game.',
        summarise: {
            prefix: 'Official minimum age'
        },
        unit: 'year'
    },
    rules: {
        linked: [],
        legacy: ['age.official']
    }
}